module.exports = __webpack_public_path__ + "img/ymjj.999cb82d.png";